import {
  Button, Dialog, DialogActions, DialogContent,
  DialogContentText, DialogTitle, Typography, makeStyles,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";

import RelatorioCalculoFinalFormWizard from './RelatorioCalculoFinalFormWizard';

const useStyles = makeStyles({
  paper: {
      maxWidth: '80%',
      width: 800,
      '@media (max-width: 900px)': {
          maxWidth: '100%',
          width: '100%',
      },
  },
  title: {
      borderBottom: '2px solid #000000',
  },
});

const ModalRelatorioCalculo = ({ isModalOpen, setIsModalOpen, ...restProps }) => {

  const { t } = useTranslation();
  const classes = useStyles();

  const fechar = t('com.muralis.qcx.acoes.fechar');

  return (
      <Dialog
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        fullWidth
        maxWidth="xl"
        PaperProps={{
          className: classes.paper,
          style: { width: '90%', height: '90%' },
        }}
      >

          <DialogContent>
            <RelatorioCalculoFinalFormWizard {...restProps}/>
          </DialogContent>


          <DialogActions>                  
            <Button variant="contained" onClick={() => setIsModalOpen(false)} color="secondary">
              {fechar}
            </Button>
          </DialogActions>

      </Dialog>
  )

}


export default ModalRelatorioCalculo;